<div id="shared-bottom-sheet-container" class="bottom-sheet">
  <div
    id="shared-bottom-sheet-title-cross-holder-id"
    class="bottom-sheet-title-cross-holder"
  >
    <div
      id="shared-bottom-sheet-title-wrapper"
      *ngIf="bottomSheetTitle"
      class="bottom-sheet-title"
    >
      <!-- TITLE -->
      <app-text id="shared-bottom-sheet-title" [textStyleType]="bottomSheetTitleFontType"
        >{{ bottomSheetTitle }}
      </app-text>
    </div>
    <div id="shared-bottom-sheet-icon-wrapper" class="bottom-sheet-closeIcon">
      <!-- CLOSE ICON -->
      <app-icon
        id="shared-bottom-sheet-close-icon"
        *ngIf="closeIconRequired"
        [name]="'close'"
        (click)="onCloseBottomSheet()"
        [size]="'2em'"
      ></app-icon>
    </div>
  </div>
  <!-- COMPONENT -->
  <div
    id="shared-bottom-sheet-component-wrapper"
    mat-dialog-content
    *ngIf="data.component"
  >
    <ng-container
      id="shared-bottom-sheet-component"
      *ngComponentOutlet="data.component"
    ></ng-container>
  </div>
  <!-- TEMPLATE -->
  <div id="shared-bottom-sheet-template-wrapper" mat-dialog-content *ngIf="data.template">
    <ng-container
      id="shared-bottom-sheet-template"
      *ngTemplateOutlet="data.template"
    ></ng-container>
  </div>
</div>
